import React, { useLayoutEffect, useRef, useState } from 'react'

const GROUP_CLASSES = 'lang-changer-group border p-2 pointer font-bold text-lg border-mudPurple text-[#9392AD] rounded-full flex flex-row w-fit'

// The collapsed rail shows only the active language as a pill; the open panel shows the
// full segmented control. Both stay mounted and crossfade (driven by the sidebar's
// data-state in CSS). While they fade, the pill slides by --sb-lang-shift so its label
// lands exactly on the active segment's label and the active language stays anchored.
const LanguageSelector = ({ langs, selectedLang, onLanguageChange }) => {
    const groupRef = useRef(null)
    const slotRef = useRef(null)
    const pillRef = useRef(null)
    const pillTextRef = useRef(null)
    const itemRefs = useRef({})
    const [shift, setShift] = useState(0)

    const activeLang = langs?.find((lang) => lang.code === selectedLang)

    // offsetLeft ignores transforms, so this measures the resting layout even mid-sweep.
    // Offset parents: items → group, text → pill → slot; group and slot → .sb-lang.
    useLayoutEffect(() => {
        const group = groupRef.current
        const measure = () => {
            const item = itemRefs.current[selectedLang]
            const slot = slotRef.current
            const pill = pillRef.current
            const pillText = pillTextRef.current
            if (!group || !item || !slot || !pill || !pillText) return
            setShift(group.offsetLeft + item.offsetLeft - (slot.offsetLeft + pill.offsetLeft + pillText.offsetLeft))
        }

        measure()

        // Web fonts or a locale change can resize the group after the first measure.
        if (!group || typeof ResizeObserver === 'undefined') return undefined
        const observer = new ResizeObserver(measure)
        observer.observe(group)
        return () => observer.disconnect()
    }, [selectedLang, langs])

    return (
        <div className="sb-lang mt-1 xl3:mt-6">
            <div ref={groupRef} className={`sb-lang__group sb-reveal ${GROUP_CLASSES}`}>
                {langs?.map((lang) => (
                    <button
                        type="button"
                        ref={(el) => {
                            itemRefs.current[lang.code] = el
                        }}
                        className={`lang-item mx-2 ${lang.code === selectedLang ? 'text-white' : ''}`}
                        key={lang.code}
                        disabled={lang.code === selectedLang}
                        onClick={(e) => {
                            e.preventDefault()
                            onLanguageChange(lang.code)
                        }}
                    >
                        {lang.name}
                    </button>
                ))}
            </div>
            {activeLang && (
                <div ref={slotRef} className="sb-rail-slot" aria-hidden="true">
                    <div ref={pillRef} className={`sb-lang__pill ${GROUP_CLASSES}`} style={{ '--sb-lang-shift': `${shift}px` }}>
                        <span ref={pillTextRef} className="lang-item mx-2 text-white">
                            {activeLang.name}
                        </span>
                    </div>
                </div>
            )}
        </div>
    )
}

export default LanguageSelector
